import { saveAs } from 'file-saver';

const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Trigger a browser download of an xlsx blob, naming the file `${fileName}.xlsx`.
 */
export const saveExcelBlob = (data: Blob, fileName: string): void => {
  saveAs(new Blob([data], { type: XLSX_MIME_TYPE }), `${fileName}.xlsx`);
};
